function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.501 14.8a.563.563 0 01-.107-.011 3.672 3.672 0 01-2.893-3.797 4.034 4.034 0 011.872-3.326 4.045 4.045 0 012.514-.627A7.111 7.111 0 0111.925 1h.082l.037.25V1c2.589 0 5.045 1.454 6.301 3.717 2.806.029 5.114 2.321 5.155 5.134a4.801 4.801 0 01-2.79 4.51.502.502 0 01-.679-.626.495.495 0 01.26-.281 3.807 3.807 0 002.21-3.579c-.034-2.294-1.923-4.157-4.21-4.157h-.063l-.156.005h-.002a.506.506 0 01-.472-.277C16.559 3.352 14.386 2 12.064 2h-.141C8.741 2 6.062 4.48 5.824 7.647a.5.5 0 01-.604.451 3.042 3.042 0 00-2.308.411 3.039 3.039 0 00-1.34 1.922 3.082 3.082 0 00-.071.598 2.684 2.684 0 002.107 2.784c.269.059.44.326.382.595a.505.505 0 01-.489.392z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 23.001a6.508 6.508 0 01-6.5-6.5c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5-2.915 6.5-6.5 6.5zm0-12c-3.033 0-5.5 2.467-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.467 5.5-5.5-2.467-5.5-5.5-5.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.173 19.43a1.236 1.236 0 01-.881-.365l-1.501-1.501a.5.5 0 11.708-.708l1.5 1.5a.247.247 0 00.177.073c.08 0 .153-.036.2-.1l2.9-3.874a.504.504 0 01.701-.1c.22.165.265.479.1.7l-2.9 3.874a1.26 1.26 0 01-1.004.501z"
});

function SvgCloudDeployed(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "cloudDeployed.f37cb.svg";
export { SvgCloudDeployed as ReactComponent };